import {Injectable} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Injectable({providedIn: 'root'})
export class RedirectService {

  constructor(private translate: TranslateService) {

  }

  redirectToIL(): void {
    this.redirectTo('RedirectSite');
  }

  redirectTo(key: string) {
    document.location.href = this.translate.instant(key);
  }
}
